export const auditEvents = [
  'Third Party - Created',
  'Third Party - Modified',
  'Third Party - Next review date applied',
  'Third Party - Approval status changed',
  'Third Party - Screening initiated',
  'Third Party - Monitoring settings modified',
  'Third Party - Review finalised',
  'Third Party - Monitoring alert(s) received',
  'Third Party - Client monitoring settings modified',
  'Third Party - Review status modified',
  'Third Party - Screening type converted',
  'Third Party - Screening report ordered',
  'Third Party - Report ready for review',
  'Third Party - Updated report ready for review',
  'Third Party - Due Diligence report ordered',
  'Third Party - Linkage Unlinked',
  'Third Party - Linkage Modified',
  'Third Party - Linkage Created',
];
